export const AUTH_SUCCESS="AUTH_SUCCESS"
export const AUTH_FAILED="AUTH_FAILED"
export const RESET_PROJECT_INFO="RESET_PROJECT_INFO";
export const SET_PROJECT_INFO="SET_PROJECT_INFO"
export const SET_ELEMENT="SET_ELEMENT"
export const LICENSE_FIX="LICENSE_FIX"
export const REFRESH_PROJECT_INFO="REFRESH_PROJECT_INFO"
export const VULNERABLE_ONLY="VULNERABLE_ONLY"
export const TOGGLE_LANGUAGE="TOGGLE_LANGUAGE"
export const COLLAPSE_ALL="COLLAPSE_ALL"
export const COLLAPSE_SECURITY="COLLAPSE_SECURITY"
export const COLLAPSE_STABILITY="COLLAPSE_STABILITY"
export const COLLAPSE_LICENSING="COLLAPSE_LICENSING"
export const COLLAPSE_HISTORY="COLLAPSE_HISTORY"
export const UPDATE_BADGES="UPDATE_BADGES"
export const SET_HISTORY_DATA="SET_HISTORY_DATA"
export const SET_HISTORY_RAW="SET_HISTORY_RAW"
export const ADD_HISTORY_REPORT="ADD_HISTORY_REPORT"
export const STORE_HISTORY_SELECTION="STORE_HISTORY_SELECTION"
export const SET_REPORT_READY="SET_REPORT_READY"
export const SET_RECOMPUTE_REMINDER="SET_RECOMPUTE_REMINDER"
export const TOGGLE_ACCOUNT_INFO="TOGGLE_ACCOUNT_INFO"
export const SET_GLOBAL_TAB="SET_GLOBAL_TAB"
export const SET_COPYRIGHT_LICENSE="SET_COPYRIGHT_LICENSE"
export const SET_REPORT_LICENSING="SET_REPORT_LICENSING"
export const TOGGLE_SECURITY_VIEWMODE="TOGGLE_SECURITY_VIEWMODE"
export const SET_PERFORMED_MULTI_LICENSE_EXCLUSION="SET_PERFORMED_MULTI_LICENSE_EXCLUSION"
export const SHOW_CLOSE_MODAL_CONFIRMATION="SHOW_CLOSE_MODAL_CONFIRMATION"
export const SET_CLOSE_MODAL_CONFIRMATION_CONFIRM_CB="SET_CLOSE_MODAL_CONFIRMATION_CONFIRM_CB"
export const SET_JIRA_ISSUE="SET_JIRA_ISSUE"
export const SET_LOCATIONS_INFO="SET_LOCATIONS_INFO"